// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1oKiN","title":"Info_title__1lObg","links":"Info_links__1DhJI","link":"Info_link__oLbIs","logo":"Info_logo__a0E4D"};